/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Button } from "reactstrap";
import CenteredModal from "./CenteredModal";

const ConfirmModal = ({
  isOpen,
  toggle,
  size,
  confirmText = "Confirm",
  confirmColor = "green",
  onConfirm,
  children
}) => {
  // handlers
  const handleConfirm = () => {
    onConfirm?.();
    toggle?.();
  };

  return (
    <CenteredModal isOpen={isOpen} toggle={toggle} size={size}>
      {children}
      <div className="mt-1 d-flex justify-content-between">
        <Button color="dark" onClick={toggle}>Cancel</Button>
        <Button color={confirmColor} onClick={handleConfirm}>
          {confirmText}
        </Button>
      </div>
    </CenteredModal>
  );
}
export default ConfirmModal;
